import type { CreateVoorraadInput, Item, VoorraadItem } from '@boodschappenlijst/shared';
import { api } from '../../lib/apiClient';

export const voorraadApi = {
  list: () => api.get<{ voorraad: VoorraadItem[] }>('/voorraad'),
  create: (input: CreateVoorraadInput) => api.post<{ item: VoorraadItem }>('/voorraad', input),
  /** Aantal bijstellen of de drempel wijzigen; alleen de meegegeven velden. */
  update: (id: string, velden: { aantal?: number; minimum?: number | null }) =>
    api.patch<{ item: VoorraadItem }>(`/voorraad/${id}`, velden),
  /** Verplaatst de regel naar de boodschappenlijst. */
  isOp: (id: string) => api.post<{ item: Item }>(`/voorraad/${id}/op`),
  remove: (id: string) => api.del<{ ok: true }>(`/voorraad/${id}`),
};
